import { render, staticRenderFns } from "./ProdutosDeCombinados.vue?vue&type=template&id=3362effe&scoped=true"
import script from "./ProdutosDeCombinados.vue?vue&type=script&lang=js"
export * from "./ProdutosDeCombinados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3362effe",
  null
  
)

export default component.exports